module.exports = __webpack_public_path__ + "media/images/childcare/main_image1@2x-eabdf65135c144a7a186aa258513e90d.jpg";